module.exports = __webpack_public_path__ + "img/img-6.5a1abb14.webp";